import API from './API.js';


class LongJobAPI extends API {

	static controllerName = 'LongJobAPI'

	
	static async getJobProgress( jobID ) {
		const data = await this.newGet( 'getJobProgress', [ jobID ] )
		return data
	}


	static async stop( jobID ) {
		return await this.newGet( 'stop', [ jobID ] )
	}



}
export default LongJobAPI;